import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
export const loadingSlice = createSlice({
    name: 'app/loading',
    initialState: {
        isLoading: false,
        pendingRequests: 0,
        startTime: null
    },
    reducers: {
        forceHideLoader: (state) => {
            state.isLoading = false;
            state.pendingRequests = 0;
            state.startTime = null;
        }
    },
    extraReducers: (builder) => {
        const shouldTrackInGlobalLoader = (action) => {
            const type = action.type;
            // Exclude specific thunks from triggering the global loader
            if (type.startsWith('collaborator/getCollaboratorsByEvent/') ||
                type.startsWith('user/getAllUsersByCompany/') ||
                type.startsWith('task/update/') ||
                type.startsWith('role/getRolesByCompanyId/') ||
                type.startsWith('collaborator/getAllCollaboratorsByCompany/') ||
                type.startsWith('football/sync-current-year') ||
                type.startsWith('formResponse/checkEmailExists/') ||
                type.startsWith('eventVehicle/checkDuplicates/') ||
                type.startsWith('pickupLocation/checkAvailability/') ||
                type.startsWith('notifications/markAsRead/') ||
                type.startsWith('notifications/markAsUnread/') ||
                type.startsWith('notifications/markAllAsRead/') ||
                type.startsWith('notifications/markAllAsUnread/') ||
                type.startsWith('/partners/suggested-people') ||
                type.startsWith('people/getAllWithoutPagination/')) {
                return false;
            }
            return true;
        };
        builder.addMatcher((action) => isPending(action) && shouldTrackInGlobalLoader(action), (state) => {
            state.pendingRequests += 1;
            state.isLoading = true;
            state.startTime = Date.now();
        });
        builder.addMatcher((action) => isFulfilled(action) && shouldTrackInGlobalLoader(action), (state) => {
            state.pendingRequests = Math.max(0, state.pendingRequests - 1);
            state.isLoading = state.pendingRequests > 0;
            if (state.pendingRequests === 0) {
                state.startTime = null;
            }
        });
        builder.addMatcher((action) => isRejected(action) && shouldTrackInGlobalLoader(action), (state) => {
            state.pendingRequests = Math.max(0, state.pendingRequests - 1);
            state.isLoading = state.pendingRequests > 0;
            if (state.pendingRequests === 0) {
                state.startTime = null;
            }
        });
    }
});
export const { forceHideLoader } = loadingSlice.actions;
export default loadingSlice.reducer;
